import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SnowEffectComponent } from './snow-effect.component';

@NgModule({
  declarations: [
    SnowEffectComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    SnowEffectComponent
  ]
})
export class SnowEffectModule { }